import React from 'react';
import { TextField } from '@mui/material';

import { Widget, InlineEditor, InlineEditorProps } from './_InlineDraftEditor';

export function StringWidget(props: Widget<string>) {
  return (
    <TextField
      style={{ width: '120px' }}
      value={props.value}
      variant="standard"
      autoFocus={true}
      onBlur={props.onBlur}
      onChange={e => props.onValueChange(e.target.value)}
    />
  );
}

export const StringInlineEditor = (props: InlineEditorProps<string>) => {
  return <InlineEditor {...props} widget={StringWidget} />;
};
